<div class="thing-grid"><Thing v-for="i in 200" :thing-id="i"></Thing></div>